import { render, staticRenderFns } from "./modal-solicitacao.vue?vue&type=template&id=6d79b1fe"
import script from "./modal-solicitacao.vue?vue&type=script&lang=js"
export * from "./modal-solicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports